import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  updatedCart: false,
};

const updatedCartSlice = createSlice({
  name: 'updatedCart',
  initialState,
  reducers: {
    updatedCart: (state, action) => {
      state.updatedCart = action.payload;
    },
  }
});

export const { updatedCart } = updatedCartSlice.actions;
export default updatedCartSlice.reducer;
